import React from "react";
import {Login as RaLogin} from 'react-admin';

export const Login = (props) => (
    <RaLogin {...props} backgroundImage={"https://source.unsplash.com/1600x900/daily/?water"}/>
);
